class EnumArray extends Array {
  // 根据值获取标签
  getLabelByValue(val) {
    return this.find(item => item?.value === val)?.label || "-";
  }

  //

}

export const createEnum = (enums) => {
  return Object.freeze(new EnumArray(...enums))
}
